import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Row } from "@faire/web--source/slate/Layout";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import { POSLogo } from "@faire/retailer-visitor-shared/features/PointOfSale/components/POSLogo";
import { usePOSSummary } from "@faire/retailer-visitor-shared/features/PointOfSale/hooks/usePOSSummary";
export var OpenSizingVariantPOSInventory = function(param) {
    var count = param.count, ref = param.ref;
    var type = usePOSSummary().type;
    return /*#__PURE__*/ _jsxs(Row, {
        align: "center",
        gap: 4,
        ref: ref,
        children: [
            /*#__PURE__*/ _jsx(POSLogo, {
                type: type,
                size: 12
            }),
            /*#__PURE__*/ _jsx(Typography, {
                children: count > 99 ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "BVfmtK",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "99+"
                        }
                    ]
                }) : count
            })
        ]
    });
};
